import { VIEW_SHELL_TOUR } from '@app/components/view-shell/tour';
import { APP_TOUR } from '@app/features/command/sidebar/tour';
import { defineViewTour } from '@app/features/tours/core/view-tour';
import { defineTourTargets } from '@ui/components/Tour';

export const AGENTS_TOUR = defineTourTargets('agents', [
  'modeSwitch',
  'newChat',
  'rosterNav',
  'picker',
  'composer',
  'agentList',
  'agentSetup',
]);

const openRoster = {
  entry: [AGENTS_TOUR.rosterNav, VIEW_SHELL_TOUR.sidebarToggle],
  entryLabel: 'Open Agents to continue',
};

export const agentsTour = defineViewTour({
  id: 'agents',
  title: 'Agents',
  steps: [
    {
      target: AGENTS_TOUR.modeSwitch,
      entry: [VIEW_SHELL_TOUR.sidebarToggle],
      entryLabel: 'Open the sidebar to continue',
      title: 'Switch between Work and Code',
      description:
        'Work shows your chat agents and their conversations. Code shows your coding agents, their sessions, and the repository each one works in.',
    },
    {
      target: AGENTS_TOUR.picker,
      entry: [AGENTS_TOUR.newChat, VIEW_SHELL_TOUR.sidebarToggle],
      entryLabel: 'Start a new conversation to continue',
      title: 'Choose your agent and model',
      description:
        'Open this picker to choose an agent for the current mode. In Work, Macro’s models are listed here too; each agent’s submenu lets you choose a model for that conversation.',
    },
    {
      target: AGENTS_TOUR.agentList,
      ...openRoster,
      title: 'Chat agents work with your context',
      description:
        'Chat agents use instructions and connected tools to research, write, and work with your documents and conversations. Your team and private agents live here.',
    },
    {
      target: AGENTS_TOUR.agentSetup,
      ...openRoster,
      title: 'Coding agents work on code',
      description:
        'Coding agents run in Cursor or on a machine you pair with macrod. Connect them here, then choose where each agent runs when you create it.',
    },
    {
      target: AGENTS_TOUR.agentList,
      ...openRoster,
      title: 'Share agents with your team',
      description:
        'Team agents are available to teammates; private agents belong to you. When creating or editing an agent, choose Team or Private alongside its instructions and tools.',
    },
    {
      target: APP_TOUR.createMenu,
      title: 'Put recurring work on a schedule',
      description:
        'Use Create → Routine to give an agent instructions and a schedule—for example, a weekly summary or daily triage. Review the routine’s runs and pause it when you need to.',
    },
  ],
});
